function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLocationArrow, faMapMarker, faMapMarked, faList, faCompass } from '@fortawesome/free-solid-svg-icons';
import Tooltip from 'rc-tooltip';
import './Navigation.css';

var Navigation = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(Navigation, _React$PureComponent);

  function Navigation(props) {
    var _this;

    _classCallCheck(this, Navigation);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Navigation).call(this, props));
    _this.state = {
      collapsed: true
    };
    return _this;
  }

  _createClass(Navigation, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          app = _this$props.app,
          searchMode = _this$props.searchMode;
      var width = this.state.width;
      return React.createElement("div", {
        className: "navigation ".concat(this.state.collapsed ? 'collapsed' : 'expanded')
      }, React.createElement(Tooltip, {
        mouseEnterDelay: .5,
        mouseLeaveDelay: .5,
        placement: "right",
        trigger: ['hover'],
        overlay: React.createElement("span", null, "Search by Track Location")
      }, React.createElement("div", {
        className: "ripple btn ".concat(searchMode === 'location' ? 'active' : ''),
        onClick: function onClick(e) {
          return app.setSearchMode('location');
        },
        alt: ""
      }, React.createElement(FontAwesomeIcon, {
        icon: faMapMarked,
        className: "icon"
      }))), React.createElement(Tooltip, {
        mouseEnterDelay: .5,
        mouseLeaveDelay: .5,
        placement: "right",
        trigger: ['hover'],
        overlay: React.createElement("span", null, "Search by Current Location")
      }, React.createElement("div", {
        className: "ripple btn ".concat(searchMode === 'currentLocation' ? 'active' : ''),
        onClick: function onClick(e) {
          return app.setSearchMode('currentLocation');
        }
      }, React.createElement(FontAwesomeIcon, {
        icon: faCompass,
        className: "icon"
      }))), React.createElement(Tooltip, {
        mouseEnterDelay: .5,
        mouseLeaveDelay: .5,
        placement: "right",
        trigger: ['hover'],
        overlay: React.createElement("span", null, "Search by Track")
      }, React.createElement("div", {
        className: "ripple track-mode btn ".concat(searchMode === 'track' ? 'active' : ''),
        onClick: function onClick(e) {
          return app.setSearchMode('track');
        }
      }, React.createElement(FontAwesomeIcon, {
        icon: faMapMarker,
        className: "map-marker"
      }), React.createElement(FontAwesomeIcon, {
        icon: faList,
        className: "list"
      }))), React.createElement("div", {
        className: "app-logo"
      }, "race day"));
    }
  }]);

  return Navigation;
}(React.PureComponent);

export default Navigation;